// Custom hook to track form progress
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export const useFormProgress = () => {
  const [formsProgress, setFormsProgress] = useState([]);
  const registrationData = useSelector(
    (state) => state?.authReducer?.registrationData,
  );

  // Helper function to check if a field is filled
  const isFieldFilled = (value) => {
    if (value === null || value === undefined) return false;
    if (typeof value === 'string') return value.trim().length > 0;
    if (typeof value === 'number') return true;
    if (Array.isArray(value)) return value.length > 0;
    if (value instanceof File) return true;
    return false;
  };

  // Calculate progress for each form
  const calculateFormProgress = () => {
    const forms = [
      {
        title: 'Basic Information',
        fields: [
          { label: 'CIN Number', key: 'cin_number' },
          { label: 'Company Name', key: 'company_name' },
          { label: 'Website', key: 'website' },
          { label: 'LinkedIn Profile', key: 'linkedin' },
          { label: 'Languages Supported', key: 'languages_supported' },
          { label: 'Address', key: 'address' },
          { label: 'PIN Code', key: 'pin_code' },
          { label: 'City', key: 'city' },
          { label: 'State', key: 'state' },
          { label: 'Country', key: 'country' },
          { label: 'Phone Number', key: 'phoneNumber' },
          { label: 'Sales Person Name', key: 'name_of_sales_person' },
          {
            label: 'Sales Person Phone Number',
            key: 'number_of_sales_person',
          },
          { label: 'Sales Person Email', key: 'email_of_sales_person' },
          { label: 'Brochure Upload', key: 'brochure' },
          { label: 'Company Documents', key: 'companyDoc' },
          { label: 'Company Presentation', key: 'companyPPT' },
        ],
        data: registrationData,
      },
      {
        title: 'Company Details',
        fields: [
          { label: 'Type of Organization', key: 'type_of_organisation' },
          { label: 'Establishment Year', key: 'establishment_year' },
          { label: 'Nature of Business', key: 'nature_of_business' },
          { label: 'Services Offered', key: 'service_offered' },
          { label: 'Software Used', key: 'software_used' },
          { label: 'Working Hours', key: 'software_used' },
          { label: 'Weekly Holidays', key: 'software_used' },
          {
            label: 'Professional Associations',
            key: 'professional_associations',
          },
          { label: 'PAN', key: 'pan_number' },
          { label: 'GST', key: 'gst_number' },
          { label: 'Revenue', key: 'revenue' },
          { label: 'Annual Turnover', key: 'annual_turnover' },
          { label: 'Udyam number', key: 'udyam_number' },
          { label: 'Factory license number', key: 'factory_license_number' },
          { label: 'Incoterms', key: 'incoterms' },
        ],
        data: registrationData,
      },
      // {
      //   title: 'Registration Details',
      //   fields: [
      //     { label: 'Tax Registration ', key: 'tax_registration' },
      //     { label: 'Excise Registration no.', key: 'excise_registration' },
      //     { label: 'Manufacturing License no.', key: 'factory_license_number' },
      //     { label: 'PAN no.', key: 'pan_number' },
      //     { label: 'Free Sale Certificate', key: 'free_sale_certificate' },
      //     { label: 'Tax Certificate proof', key: 'tax_certificate_upload' },
      //     { label: 'PAN number proof', key: 'pan_number_upload' },
      //     {
      //       label: 'Excise Registration proof',
      //       key: 'excise_registration_upload',
      //     },
      //     {
      //       label: 'Factory Liscence proof',
      //       key: 'factory_license_number_upload',
      //     },
      //     {
      //       label: 'Sale Certificate proof',
      //       key: 'free_sale_certificate_upload',
      //     },
      //   ],
      //   data: registrationData,
      // },
      {
        title: 'Technical Details',
        fields: [
          { label: 'Capacity', key: 'capacity' },
          { label: 'Industries Served', key: 'industries_served' },
          { label: 'Manufacturing Processes', key: 'manufacturing_processes' },
          // { label: 'Machines', key: 'number_of_machinery' },
          // { label: 'Plants/Facilities', key: 'number_of_plants_facilities' },
          { label: 'Materials Used', key: 'materials' },
          // { label: 'Work Samples', key: 'workSample_one' },
        ],
        data: registrationData,
      },
      {
        title: 'Upload Certificates',
        fields: [
          { label: 'ISO 13485', key: 'iso_13485' },
          { label: 'ISO/TS 16949', key: 'iso_ts_16949' },
          { label: 'ISO 9000', key: 'iso_9000' },
          { label: 'ISO 14644', key: 'iso_14644' },
          { label: 'ISO 14001', key: 'iso_14001' },
          { label: 'ISO 14937', key: 'iso_14937' },
          { label: 'ISO 15378', key: 'iso_15378' },
          { label: 'ISO 17665', key: 'iso_17665' },
          { label: 'FDA Approvals', key: 'fda_approvals' },
        ],
        data: registrationData,
      },
      /*
        in Upload Specific Certificates we have 4 fields each having 4 subfields
        even if one of the field is filled we mark it as filled
      */
      // {
      //   title: 'Upload Specific Certificates',
      //   fields: [
      //     {
      //       label: 'Environmental ',
      //       key: 'environmentalCertificates',
      //     },
      //     { label: 'Quality ', key: 'qualityCertificates' },
      //     { label: 'HIPAA ', key: 'hipaaCertificate' },
      //     { label: 'Regulatory Certificates', key: 'regulatoryCertificates' },
      //   ],
      //   data: registrationData,
      // },

      {
        title: 'Refrences & Testimonials',
        fields: [
          { label: 'Major Customers', key: 'who_are_your_major_customers' },
        ],
        data: registrationData,
      },
      {
        title: 'Plant Information',
        fields: [
          // { label: 'Plant Name', key: 'plantName' },
          // { label: 'Plant Area', key: 'plantArea' },
          // { label: 'People Working', key: 'peopleWorking' },
          // { label: 'Location', key: 'location' },
          // { label: 'Machines in Plant', key: 'machinesInPlant' },
          // { label: 'Number of Washrooms', key: 'numberOfWashrooms' },
          // { label: 'Number of Staff Rooms', key: 'numberOfStaffRooms' },
          {
            label:
              '🏭 Your plants are unique! Help us understand your manufacturing footprint. Please add details about all your plants',
            key: 'dummy',
          },
        ],
        data: registrationData,
      },
      {
        title: 'Machines Information',
        fields: [
          // { label: 'Machine Name', key: 'machine_name' },
          // { label: 'Make and Model', key: 'machine_make_model' },
          // { label: 'Machine Capacity', key: 'machineCapacity' },
          // { label: 'Last Calibrated On', key: 'lastCalibratedOn' },
          // { label: 'Table Size', key: 'tableSize' },
          // { label: 'Uptime', key: 'upTime' },
          // { label: 'Machine Age', key: 'machineAge' },
          // { label: 'Maintenance Cycle', key: 'maintenanceCycle' },
          // { label: 'Skilled Operators', key: 'skilledOperators' },
          {
            label:
              '🛠️ Stand out to potential buyers! List your key machinery and equipment to demonstrate your manufacturing capabilities.',
            key: 'dummy',
          },
        ],
        data: registrationData,
      },
    ];

    return forms.map((form) => {
      // Check filled fields using the key property
      const filledFields = form.fields.filter((field) =>
        isFieldFilled(form.data?.[field.key]),
      );

      // Calculate progress percentage
      const progress = Math.round(
        (filledFields.length / form.fields.length) * 100,
      );

      // Get missing fields - just the labels as strings
      const missingFields = form.fields
        .filter((field) => !isFieldFilled(form.data?.[field.key]))
        .map((field) => field.label); // Extract just the label string

      return {
        title: form.title,
        progress,
        missingFields: missingFields.length > 0 ? missingFields : [''], // Now it's an array of strings
        totalFields: form.fields.length,
        completedFields: filledFields.length,
      };
    });
  };

  useEffect(() => {
    const progress = calculateFormProgress();
    setFormsProgress(progress);
  }, [registrationData]);

  // Debug log to check the structure
  // useEffect(() => {}, [formsProgress]);

  return formsProgress;
};
